import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs, fadeInUp, stagger } from './data';

export const FAQSection = ({ openFaq, setOpenFaq }) => (
  <section id="faq" aria-label="Frequently Asked Questions" className="py-20 md:py-32">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="text-center mb-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={stagger}
      >
        <motion.p variants={fadeInUp} className="text-amber-400 font-semibold mb-4">FAQ</motion.p>
        <motion.h2 variants={fadeInUp} className="text-3xl md:text-5xl font-bold mb-6 text-white">
          Frequently Asked Questions
        </motion.h2>
      </motion.div>

      <div className="space-y-4">
        {faqs.map((faq, idx) => (
          <motion.div
            key={faq.q}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            transition={{ delay: idx * 0.05 }}
          >
            <button
              onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
              className="w-full bg-neutral-900 border border-white/5 rounded-lg p-6 text-left hover:border-amber-500/30 transition-colors"
              data-testid={`faq-${idx}`}
            >
              <div className="flex items-center justify-between">
                <h3 className="font-semibold pr-8 text-white">{faq.q}</h3>
                <ChevronDown className={`w-5 h-5 text-amber-400 transition-transform ${openFaq === idx ? 'rotate-180' : ''}`} />
              </div>
              {openFaq === idx && (
                <motion.p
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  className="text-gray-400 mt-4 leading-relaxed"
                >
                  {faq.a}
                </motion.p>
              )}
            </button>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
